import { render, staticRenderFns } from "./adminTabBooking.vue?vue&type=template&id=4f0033c2&scoped=true&"
import script from "./adminTabBooking.vue?vue&type=script&lang=ts&"
export * from "./adminTabBooking.vue?vue&type=script&lang=ts&"
import style0 from "./adminTabBooking.vue?vue&type=style&index=0&id=4f0033c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0033c2",
  null
  
)

export default component.exports